// ds-color-ignore-file: dev-only / internal tooling surface
"use client"

/** Non-blocking notice that the body being edited has a newer unpublished draft
 *  in the CMS than the published version shown on the page. (AHD-7396) */
export function DraftBanner({ show }: { show: boolean }) {
  if (!show) return null
  return (
    <div
      data-ahead-editor-ui
      style={{
        position: "fixed",
        top: 8,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 2147483601,
        background: "#fff7e6",
        border: "1px solid #f0c36d",
        color: "#7a5a00",
        borderRadius: 8,
        padding: "6px 12px",
        fontSize: 12,
        fontFamily: "ui-sans-serif, system-ui",
        boxShadow: "0 6px 18px rgba(0,0,0,.12)",
      }}
    >
      This article has a newer unpublished draft — you&apos;re editing the
      published version.
    </div>
  )
}
